"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function BackuppoliciesGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__backuppolicies-green-multitone-filled__clip0_13467_110)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M4.725 6.397c0-.48.013-.65.472-.65h4.039a.81.81 0 01.564.231l.776.68.8.781a.89.89 0 01.239.61v6.365c0 .48-.372.87-.831.87H5.555c-.459 0-.83-.39-.83-.87V6.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    fillRule: "evenodd",
    d: "M3.982 11.25H3.24C1.44 11.25 0 9.81 0 8.01c0-1.08.56-2.08 1.44-2.68-.04-.24-.08-.48-.08-.72 0-1.8 1.44-3.24 3.24-3.24.32 0 .6.04.88.12C6.4.53 7.68.01 9.04.01c2.72 0 4.92 2.2 4.92 4.92v.08c1.2.48 2.04 1.68 2.04 3 0 1.8-1.44 3.24-3.24 3.24h-.483V7.824a1 1 0 00-.287-.702l-.9-.912-.997-.924a1 1 0 00-.68-.267h-4.43a1 1 0 00-1 1v5.233zm7.495 0H4.782V6.019c0-.11.09-.2.2-.2h4.444v2.033h2.051v3.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M12.267 11.244h.58c1.646 0 3.153-1.456 3.153-3.102 0-1.35-.819-2.773-2.085-3.111v-.38c0-2.617-2.375-4.612-4.992-4.612-.247 0-.49.018-.726.052 2.29.342 3.917 2.422 3.917 4.801v.38c1.267.338 2.153 1.52 2.153 2.87 0 .936-.354 3.102-2 3.102z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.965 10.14H9.76a1.71 1.71 0 00-.206-.516l.139-.138a.373.373 0 00-.527-.526l-.127.127a1.635 1.635 0 00-.53-.224v-.176a.373.373 0 10-.747 0v.176a1.65 1.65 0 00-.526.224l-.127-.127a.374.374 0 10-.53.526l.142.138a1.71 1.71 0 00-.213.515h-.205a.373.373 0 100 .747h.224c.043.174.115.339.212.49l-.168.167a.373.373 0 00.122.61.374.374 0 00.409-.08l.179-.183c.147.089.307.153.474.19v.262a.373.373 0 00.747 0v-.261c.168-.037.33-.102.477-.19l.18.179a.373.373 0 10.526-.527l-.164-.168c.097-.15.169-.315.213-.489h.224a.373.373 0 100-.746h.007zm-2.397 1.045a.91.91 0 01.553-1.62h.033a.907.907 0 01.893.91.897.897 0 01-.344.713.918.918 0 01-1.135-.003zM9.39 7.734V5.048l2.89 2.686H9.39z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__backuppolicies-green-multitone-filled__clip0_13467_110"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

BackuppoliciesGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
BackuppoliciesGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = BackuppoliciesGreenMultitoneFilled;
exports["default"] = _default;